import React from 'react';

export const HeroStats = ({ stats }) => (
  <div className="flex mt-12" style={{ gap: '40px' }}>
    {stats.map((s) => (
      <div key={s.label}>
        <div className="font-bebas" style={{ fontSize: '36px', color: '#C9A84C', lineHeight: 1 }}>
          {s.value}
        </div>
        <div className="font-body uppercase mt-1" style={{ fontSize: '10px', letterSpacing: '2px', color: '#C2C1B6' }}>
          {s.label}
        </div>
      </div>
    ))}
  </div>
);
